module.exports = __webpack_public_path__ + "img/facebook icon.65df09db.png";